import { getAllUsersAssociatedWithAGroupV2 } from './API';
import { extractApiErrorMessage } from 'src/utils/apiErrorUtils';


const GetAllUsersAssociatedWithAGroup = async (accessToken, exportFlag, selectedGroupIds) => {
    try {
      const { data } = await getAllUsersAssociatedWithAGroupV2(accessToken);
      if(exportFlag){
        const users = data.filter(group => selectedGroupIds.some(g => group.id === g.group.id)).map(userInGroup => userInGroup.users.filter(u => !u.status).map(user => 
            ({
              'Full Name': user.fullName,
              'Group Name': user.groupName,
              'Email Address': user.emailAddress,
              'Default Role': user.roleName
            })
        ))

        return { success: true, data: users.flat() };
      } else {
        const users = data;
        if(users.length === 0){
          return { success: false, data: 'No users found.' };
        }
        return { success: true, data: users};
      }
    } catch (error) {
      return { success: false, data: extractApiErrorMessage(error) };
    }
  };
  
  export default GetAllUsersAssociatedWithAGroup;